import { Controller } from '@hotwired/stimulus';

// Enforces feature dependencies on checkbox forms.
// When a prerequisite feature is unchecked, its dependents are unchecked and disabled.
//
// Uses OrganisationUser::FEATURE_DEPENDENCIES serialised as a JSON data attribute
// on the controller element: data-feature-dependency-map-value='{"manage_all_reports":"manage_reports"}'
//
// Each checkbox that participates must have data-feature-dependency-target="checkbox"
// and data-feature-key="<feature_key>".
export default class extends Controller {
  static targets = ['checkbox'];
  static values = { map: Object }; // { dependent: prerequisite }

  connect() {
    this.enforce();
  }

  // Called on change of any checkbox
  enforce() {
    this.checkboxTargets.forEach((cb) => {
      const key = cb.dataset.featureKey;
      const prerequisite = this.mapValue[key];
      if (!prerequisite) return;

      const prerequisiteCheckbox = this.checkboxTargets.find(
        (c) => c.dataset.featureKey === prerequisite
      );
      const prerequisiteMet =
        prerequisiteCheckbox &&
        prerequisiteCheckbox.checked &&
        !prerequisiteCheckbox.disabled;

      if (!prerequisiteMet) {
        cb.checked = false;
        cb.disabled = true;
      } else if (cb.dataset.originalDisabled !== 'true') {
        // Re-enable only if the checkbox wasn't already disabled for another reason
        // (e.g. role-based disabling). We store the role-based disabled state
        // in originalDisabled on first run.
        cb.disabled = false;
      }
    });
  }

  // Capture the role-based disabled state so we don't override it
  checkboxTargetConnected(cb) {
    cb.dataset.originalDisabled = cb.disabled ? 'true' : 'false';
  }
}
